import Cookie from "../utils/Cookie";
import Repository from "./Repository";

export default class CookieRepository<T> extends Repository<T> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected set(value: T): Promise<void> {
        window.alert("Function not implemented yet");
        return Promise.resolve();
    }

    protected get(): Promise<T | undefined> {
        const item = Cookie.getCookie(this.storageKey);
        return Promise.resolve(item !== undefined ? JSON.parse(`"${item}"`) : undefined);
    }

    protected clear(): Promise<void> {
        return Promise.resolve(Cookie.removeCookie(this.storageKey));
    }
}
